import { render, staticRenderFns } from "./Generator.vue?vue&type=template&id=2a7b470e&"
import script from "./Generator.vue?vue&type=script&lang=js&"
export * from "./Generator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports